import { Component, OnInit } from '@angular/core';
import { EnvoiService } from 'src/app/services/envoi.service';

@Component({
  selector: 'app-envoi',
  templateUrl: './envoi.component.html',
  styleUrls: ['./envoi.component.css']
})
export class EnvoiComponent implements OnInit {

  envoiCols = [
    {field:"num_point_accueil", header:"Login PTL"}
  ];

  envoiData = [];

  loading : boolean = false;

  constructor(private envoiService:EnvoiService) { }

  ngOnInit(): void {
    this.getLivrables();
  }

  getLivrables(){
    this.loading = true;

      this.envoiService.recupererLivrables()
      .subscribe((value) => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
          alert("une erreur s'est produite");
          this.loading = false;
        }else {
          let data = value["data"];
          this.envoiData = data;
          this.loading = false;
        }
      });
  }

  previsualiser(idModeration : number) {
    let link = "" + window.location.origin + "/visualisation/" + idModeration;
    this.openLinkOnNewTab(link); 
  }

  /**
   * Permet d'ouvrir le lien dans un nouvel onglet
   */
  openLinkOnNewTab(link : string ){
    var url = encodeURI(link);
    window.open(url, "_blank");
  }

  envoyerFiche(idModeration){
    this.loading = true;

    this.envoiService.envoyerFiche(idModeration)
    .subscribe((value) => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
        alert("une erreur s'est produite");
        this.loading = false;
      }else {
        this.getLivrables();
      }
    });
  }

}
